package com.xtream.ui.tv.presentation.discover

 import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.xtream.composeapp.data.Screen


@Composable
fun TvDiscoverScreen(
    navKey: Screen,
    modifier: Modifier = Modifier,
    contentPadding: PaddingValues = PaddingValues(vertical = 24.dp),
    rowsContentPadding: PaddingValues,
    restoreFocus: Boolean = true,
) {

/*

    val activity = LocalActivity.current as ViewModelStoreOwner
    val rootNavViewModel: RootNavViewModel = koinViewModel(viewModelStoreOwner = activity)
    val homeStreamsViewModel: HomeViewModel = koinViewModel()
    val adViewModel: AdViewModel = koinViewModel(key = "ad_${navKey::class.simpleName}${navKey.hashCode()}")
    val vodInfoViewModel: VodInfoViewModel = koinViewModel(parameters = { parametersOf(null) })
    val tvShowInfoViewModel: SeriesInfoViewModel = koinViewModel(parameters = { parametersOf(null) })

    val recentMap by homeStreamsViewModel.recentMap.collectAsStateWithLifecycle()
    val adState = adViewModel.bannerState

    val columnFocusRequester = remember { FocusRequester() }
    val defaultRowFocusRequester = remember { FocusRequester() }

    // var streamInfo by remember { mutableStateOf(StreamInfoState()) }
    //var pendingFocusedItem by remember { mutableStateOf<BaseStream?>(null) }
    var wasFocusedFirstTime by rememberSaveable { mutableStateOf(false) }

    val list = remember(recentMap) { recentMap?.toList() ?: emptyList() }

    val layoutDirection = LocalLayoutDirection.current
    val isRtl = layoutDirection == LayoutDirection.Rtl

    val density = LocalDensity.current
    val screenWidthDp = with(density) {
        LocalWindowInfo.current.containerSize.width.toDp()
    }


    val startPadding = rowsContentPadding.calculateStartPadding( layoutDirection)

    val parentFraction = remember(screenWidthDp) {
        startPadding.value / screenWidthDp.value
    }

    // var backdrop by remember { mutableStateOf<String?>(null) }
    // var selectedItem by remember { mutableStateOf<BaseStream?>(null) }
    // var streamInfo by remember { mutableStateOf(StreamInfoState()) }

    val colorPaletteViewModel = koinActivityViewModel<DominantColorViewModel>()
    val backdropColor by colorPaletteViewModel.backdropColor
        .collectAsStateWithLifecycle()

    val defaultColor = MaterialTheme.colorScheme.background.lightenColor(-.05f)

    val animatedBgColor by animateColorAsState(
        targetValue = backdropColor ?: defaultColor,
        animationSpec = tween(800),
        label = "bgColor"
    )

    val sizeResolver: ConstraintsSizeResolver = rememberConstraintsSizeResolver()

    TvContentScreen(
        items = list,
        backgroundContent = {
            */
/*   BackdropImage(
                   backdrop = streamInfo.backdrop,
                   modifier = Modifier.padding(top = 20.dp)
               )*//*

        },
        modifier = modifier

            .drawBehind {
                val gradientBrush = Brush.linearGradient(
                    colors = listOf(
                        animatedBgColor,
                        animatedBgColor.copy(alpha = .5f),
                        animatedBgColor.copy(alpha = .2f),
                        Color.Transparent
                    ),
                    start = if (isRtl) {
                        Offset(0f, 0f) // Top-Left
                    } else {
                        Offset(size.width, 0f) // Top-Right
                    },
                    end = if (isRtl) {
                        Offset(size.width, size.height) // Bottom-Right
                    } else {
                        Offset(0f, size.height) // Bottom-Left
                    }
                )

                drawRect(brush = gradientBrush)
            }
            .graphicsLayer(compositingStrategy = CompositingStrategy.Offscreen),
        */
/* .graphicsLayer {
            compositingStrategy = CompositingStrategy.Offscreen
        }.drawWithContent {
            drawContent()
            drawRect(

                brush = Brush.horizontalGradient(
                    colors = listOf(
                        Color.Black.copy(alpha = .05f),
                        Color.Black.copy(alpha = .1f),
                        Color.Black.copy(alpha = .1f),
                        Color.Black.copy(alpha = .15f),
                        Color.Black
                    ),
                    startX = 0f,
                    endX = startPadding.toPx()+15
                ),
                blendMode = BlendMode.DstIn // This masks the content
            )
        },*//*

        columnFocusRequester = columnFocusRequester,
        defaultRowFocusRequester = defaultRowFocusRequester,
        itemKey = { _, (rowId, _) -> "rowId_$rowId" }, // ✅ was bare Int
        config = TvColumnConfig(
            headerMode = TvColumnHeaderMode.AutoHide,
            backgroundAlignment = Alignment.TopEnd,
            backgroundFillFraction = 0.6f,
            backgroundHidesWithHeader = false,
            headerPadding = PaddingValues(top = 24.dp)

        ),
        // ✅ Backdrop image as background

        // ✅ Stream info panel as header
        header = {
            Row(
                modifier= Modifier .fillMaxWidth(),
                horizontalArrangement = Arrangement.End,
            ) {
                Image(
                    painter = painterResource(id = R.drawable.logo),
                    contentDescription = stringResource(R.string.app_logo_login_screen),

                    contentScale = ContentScale.Crop,
                    modifier = Modifier
                        .padding(horizontal = 48.dp)
                        //.padding(vertical = 24.dp, horizontal = 16.dp)
                        //.align(Alignment.TopEnd)
                        .height(30.dp)
                        .width(68.dp)   // 🔥 FIXED width + height



                )
            }

            Spacer(modifier = Modifier.height(8.dp))
        },
        // ✅ Ad at the bottom as footer
        footer = {
            when (adState) {
                is ApiSealed.Success<Ad> -> item {
                    val currentLocale = LocalConfiguration.current.locales[0].language
                    val data = adState.data
                    AdCard(
                        data,
                        modifier = Modifier.onFocusChanged { focusState ->
                            */
/*if (focusState.isFocused) {
                                hasInitialFocus = true
                                pendingFocusedItem = null
                                streamInfo = StreamInfoState(
                                    title = data.title?.localize(currentLocale),
                                    overview = data.description?.localize(currentLocale),
                                    backdrop = data.localizedImage(currentLocale),
                                )
                            }*//*

                        },
                        contentPadding = rowsContentPadding,
                        onBitmapLoaded = {
                            colorPaletteViewModel.updateColorFromDrawable(it)
                        }
                    )
                }
                else -> {}
            }
        },
        itemRow = { _, (rowId, pair), rowFocusRequester ->
            val (aspectRatio, streams) = pair
            val focusState = rememberRowFocusState()

                PositionFocusedItemInLazyLayout(
                    parentFraction = parentFraction,
                    childFraction = 0f,
                ) {
                    // var focusedIndex by remember { mutableIntStateOf(-1) }



                    LazyContentRow(
                        modifier = Modifier
                        ,
                        title = stringResource(rowId),
                        focusRequester = rowFocusRequester,
                        focusRestorer = focusState.currentRestorer,

                        contentPadding = PaddingValues( start = startPadding, end=screenWidthDp),
                    ) {

                        itemsIndexed(
                            streams,
                            key = { _, item -> "streamId_${item.streamId}" } // ✅ was bare Int
                        ) { itemIndex, stream ->


                            // 2. Determine target alpha based on focus position
                            // If an item is to the left of the focus, dim it.
                            */
/* val targetAlpha = if (focusedIndex != -1 && itemIndex < focusedIndex) 0.2f else 1f

                             // 3. Animate the change
                             val animatedAlpha by animateFloatAsState(
                                 targetValue = targetAlpha,
                                 animationSpec = tween(durationMillis = 300),
                                 label = "alphaConnector"
                             )*//*

                            NetworkImageCard(
                                // ✅ focusState.itemModifier replaces manual rowItemFocusRequest on item 0
                                modifier = focusState
                                    .itemModifier(itemIndex)
                                    .focusAlphaFade(
                                        itemIndex = itemIndex,
                                        lastFocusedIndex = { focusState.lastFocusedItem },
                                    )


                                */
/*.graphicsLayer { alpha = animatedAlpha } // Apply the alpha
                                .onFocusChanged { state ->
                                    if (state.isFocused) {
                                        focusedIndex = itemIndex
                                    }
                                }*//*
,

                                width = if (stream is BaseTrending) 196.dp else 124.dp,
                                src = (stream as? BaseTrending)?.backdrop.addTMDBPrefixImageURL()
                                    ?: stream.streamIcon,
                                title = stream.name ?: "",
                                infoSectionVisibility = Visibility.HIDE,
                                aspectRatio = aspectRatio,
                                sizeResolver=sizeResolver,
                                onBitmapLoaded =  { bitmap ->
                                    colorPaletteViewModel.updateColorFromDrawable(bitmap)
                                },
                                onClick = {
                                    with(rootNavViewModel) {
                                        when (stream) {
                                            is LiveStream -> navigate(LiveStreamPlayer(stream.streamId, stream.categoryId, stream.name))
                                            is VodStream, is TrendingMovie -> navigate(Screen.MovieDetail(stream.streamId))
                                            is SeriesStream, is TrendingTvShow -> navigate(Screen.TvShowDetail(stream.streamId))
                                        }
                                    }
                                }
                            )
                        }

                    }
                }


        }
    )


    LaunchedEffect(navKey) { adViewModel.loadAd(AllConst.AD_LEADERBOARD) }


    LaunchedEffect(list) {
        if(restoreFocus && !wasFocusedFirstTime)
            if(!list.isEmpty()){
                wasFocusedFirstTime= columnFocusRequester.requestFocus()

            }
    }
*/


}